import {ParamsOptions} from "../types";

export default function getParams(options?: ParamsOptions) {
  if (!options) {
    return new URLSearchParams();
  }

  const params = new URLSearchParams();

  if (options.page) {
    params.append("page[limit]", String(options.page.limit));
    params.append("page[offset]", String(options.page.offset));
  }

  if (options.filter) {
    Object.entries(options.filter).forEach(([key, value]) => {
      if (value === undefined || value === null) return;
      if (Array.isArray(value)) {
        params.append(`filter[${key}]`, value.map(String).join(","));
      } else {
        params.append(`filter[${key}]`, String(value));
      }
    });
  }

  if (options.sort) {
    params.append("sort", options.sort);
  }

  if (options.view) {
    params.append("view", options.view);
  }

  return params;
}
